import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { first } from 'rxjs/operators';
import { WebConstants } from 'src/app/util/web.constants';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrUtil } from 'src/app/util/toastr.util';
import { getStatusCode, getStatusMessage } from 'src/app/util/web.util';
import { RolePrivilegeService } from 'src/app/services/role.privilege.service';

@Component({
  selector: 'app-menu-privilege-dialog',
  templateUrl: './menu-privilege-dialog.component.html',
  styleUrls: ['./menu-privilege-dialog.component.scss']
})
export class MenuPrivilegeDialogComponent implements OnInit {
  public menuObject: any = null;
  public form: any;

  constructor(public dialog: MatDialogRef<MenuPrivilegeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public rolePrivilegeService: RolePrivilegeService,
    public toaster: ToastrUtil) {
    this.init(data);
  }

  ngOnInit() {
  }

  init(data: any): void {
    this.form = new FormGroup({
      id: new FormControl(""),
      privilegeId: new FormControl(""),
      privilegeName: new FormControl(""),
      menuName: new FormControl("", Validators.required),
      menuCssClass: new FormControl("", Validators.required),
      menuHref: new FormControl("", Validators.required),
      status: new FormControl("", Validators.required)
    });

    this.getByPrivilegeId(data);
  }

  getByPrivilegeId(data: any): void {
    this.form.get('privilegeId').setValue(this.data.id);
    this.form.get('privilegeName').setValue(this.data.name);
    this.form.get("privilegeName").disable();

    this.rolePrivilegeService.getMenuByPrivilegeId(data.id)
      .pipe(first())
      .subscribe(response => {
        //this.form.get('privilegeId').setValue(this.data.id);
        //this.form.get('privilegeName').setValue(this.data.name);
        //this.form.get("privilegeName").disable();

        if (response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.menuObject = response.data;

          ////console.log("this.menuObject={}", this.menuObject);

          this.form.get('id').setValue(this.menuObject.id);
          this.form.get('menuName').setValue(this.menuObject.menuName);
          this.form.get('menuCssClass').setValue(this.menuObject.menuCssClass);
          this.form.get('menuHref').setValue(this.menuObject.menuHref);
          this.form.get('status').setValue(getStatusMessage(this.menuObject.status));
        } else {
          //alert(response.value);
        }
      });
  }

  update(): void {
    let menuPrivilegeObject = null;
    ////console.log("update.data={}", this.form.value);

    if (this.form.value.id === "") {
      menuPrivilegeObject = {
        privilegeId: this.form.value.privilegeId,
        menuName: this.form.value.menuName,
        menuCssClass: this.form.value.menuCssClass,
        menuHref: this.form.value.menuHref,
        status: getStatusCode(this.form.value.status),
      };

      this.rolePrivilegeService.addMenu(menuPrivilegeObject)
        .pipe(first())
        .subscribe(response => {
          if (response.code === WebConstants.STATUS.CODE_SUCCESS) {
            this.toaster.success("Preference has been updated", "Success");

            this.closeDialog();
          }
        });
    } else {
      menuPrivilegeObject = {
        id: this.form.value.id,
        privilegeId: this.form.value.privilegeId,
        menuName: this.form.value.menuName,
        menuCssClass: this.form.value.menuCssClass,
        menuHref: this.form.value.menuHref,
        status: getStatusCode(this.form.value.status),
      };

      this.rolePrivilegeService.updateMenu(menuPrivilegeObject)
        .pipe(first())
        .subscribe(response => {
          if (response.code === WebConstants.STATUS.CODE_SUCCESS) {
            this.toaster.success("Preference has been updated", "Success");

            this.closeDialog();
          }
        });
    }
  }

  closeDialog(): void {
    this.dialog.close();
  }
}